export default __webpack_public_path__ + "static/media/unsc agenda.b53d9f9b.png";